import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import AmpEnvelope from "../Components/AmpEnvelope";

var Voice =
/*#__PURE__*/
function () {
  function Voice(context) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "sawtooth";
    var gain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;

    _classCallCheck(this, Voice);

    this.context = context;
    this.type = type;
    this.value = -1;
    this.gain = gain;
    this.output = this.context.createGain();
    this.partials = [];
    this.output.gain.value = this.gain;
    this.ampEnvelope = new AmpEnvelope(this.context);
    this.ampEnvelope.connect(this.output);
  }

  _createClass(Voice, [{
    key: "init",
    value: function init() {
      var osc = this.context.createOscillator();
      osc.type = this.type;
      osc.connect(this.ampEnvelope.output);
      osc.start(this.context.currentTime);
      this.partials.push(osc);
    }
  }, {
    key: "on",
    value: function on(MidiEvent) {
      this.value = MidiEvent.value;
      this.partials.forEach(function (osc) {
        osc.frequency.value = MidiEvent.frequency;
      });
      this.ampEnvelope.on(MidiEvent.velocity || MidiEvent);
    }
  }, {
    key: "off",
    value: function off(MidiEvent) {
      var _this = this;

      this.ampEnvelope.off(MidiEvent);
      this.partials.forEach(function (osc) {
        osc.stop(_this.context.currentTime + _this.ampEnvelope.release * 4);
      });
    }
  }, {
    key: "connect",
    value: function connect(destination) {
      this.output.connect(destination);
    }
  }, {
    key: "attack",
    set: function set(value) {
      this.ampEnvelope.attack = value;
    },
    get: function get() {
      return this.ampEnvelope.attack;
    }
  }, {
    key: "decay",
    set: function set(value) {
      this.ampEnvelope.decay = value;
    },
    get: function get() {
      return this.ampEnvelope.decay;
    }
  }, {
    key: "sustain",
    set: function set(value) {
      this.ampEnvelope.sustain = value;
    },
    get: function get() {
      return this.ampEnvelope.sustain;
    }
  }, {
    key: "release",
    set: function set(value) {
      this.ampEnvelope.release = value;
    },
    get: function get() {
      return this.ampEnvelope.release;
    }
  }]);

  return Voice;
}();

export { Voice as default };